/**
 * Valores de ação de agendamento (schedule). Única fonte para listagem e formulários.
 * Labels são resolvidos via i18n: SCHEDULES.ACTIONS.<value>
 */
export const SCHEDULE_ACTION_VALUES = Object.freeze([
    'justify_pos',
    'delete_route',
    'lock_checkin',
])
